import { Component } from '@angular/core';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-quality-of-service',
  imports: [FeatureHero],
  templateUrl: './quality-of-service.html',
  styleUrl: './quality-of-service.scss',
})
export class QualityOfService {

}
